import { ReactNode } from "react";
import { IntercomProvider } from "react-use-intercom";
import {
  SellarContextActionEnum,
  useSellarContext,
} from "./useSellarContext.shared";

export const SellarIntercomProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [, dispatch] = useSellarContext();
  return (
    <IntercomProvider
      appId={import.meta.env.VITE_INTERCOM_CLIENT_ID}
      autoBoot={import.meta.env.VITE_ENV === "production"}
      onUnreadCountChange={(unreadCount: number) =>
        dispatch({
          type: SellarContextActionEnum.CHANGE_UNREAD_MESSAGE_COUNT,
          unreadMessageCount: unreadCount,
        })
      }
    >
      {children}
    </IntercomProvider>
  );
};
